type RichTextItem = {
  children: [
    {
      text?: string;
      url?: string;
    }
  ];
};

export function hasRichTextContent(value: string): boolean {
  try {
    const parsedContent = JSON.parse(value) as RichTextItem[];
    return parsedContent?.some((item) => {
      return item.children.some((c) => c.text || c.url);
    });
  } catch (error) {
    return false;
  }
}
